export class SessionTimeoutService {
  sessionLengthInSeconds: number;
  warningThresholdPercentage: number;
  intervalId: number | null;
  startDateTimestamp: number;
  sessionWarningCallback: (() => void) | null;
  sessionExpiredCallback: (() => void) | null;

  constructor(sessionLengthInSeconds: number, warningThresholdPercentage = 10) {
    this.sessionLengthInSeconds = sessionLengthInSeconds;
    this.warningThresholdPercentage = warningThresholdPercentage;
    this.intervalId = null;
    this.startDateTimestamp = Date.now();

    this.sessionWarningCallback = null;
    this.sessionExpiredCallback = null;
  }

  /**
   * Register a function to be called when the session is about to expire.
   */
  registerWarningFunction(sessionWarningCallback: () => void) {
    this.sessionWarningCallback = sessionWarningCallback;
  }

  /**
   * Register a function to be called when the session has expired.
   */
  registerExpiredFunction(sessionExpiredCallback: () => void) {
    this.sessionExpiredCallback = sessionExpiredCallback;
  }

  /**
   * Start the session timeout watcher.  Once started, the watcher will call the
   * registered warning function when the session is about to expire, and the
   * registered expired function when the session has expired.
   */
  start(intervalFunction: (handler: Function, timeout: number) => number) {
    this.intervalId = intervalFunction(() => {
      const expiresAt =
        this.startDateTimestamp + this.sessionLengthInSeconds * 1000;
      const warnAt =
        expiresAt -
        this.sessionLengthInSeconds *
          1000 *
          (this.warningThresholdPercentage / 100);
      const now = Date.now();

      if (now > expiresAt && this.sessionExpiredCallback) {
        // console.log("EXPIRED")
        this.sessionExpiredCallback();
        return;
      }

      if (now > warnAt && this.sessionWarningCallback) {
        // console.log("WARNING")
        this.sessionWarningCallback();
      }

      // console.log("NONE")
    }, 1000);
  }

  /**
   * Stop the session timeout watcher.
   */
  stop(intervalFunction: (id: number) => void) {
    if (this.intervalId) {
      intervalFunction(this.intervalId);
      this.intervalId = null;
    }
  }

  /**
   * Reset the session timeout watcher's start time to the current time.
   */
  renewSessionTime() {
    this.startDateTimestamp = Date.now();
  }
}
